import GeneralSetting from "./GeneralSetting";
import Tabs from "@standard/components/Tabs";
import MobileSetting from "./MobileSetting";

export default function SettingTabs({ value, onChange, setIsLoading }) {
  const items = [
    {
      key: "general",
      label: "General",
      content: (
        <GeneralSetting
          setIsLoading={setIsLoading}
          value={value}
          onChange={onChange}
          active={true}
        />
      ),
    },
    {
      key: "mobile",
      label: "Mobile",
      content: <MobileSetting value={value} onChange={onChange} />,
    },
  ];

  return (
    <div className="col-12">
      <Tabs items={items} />
    </div>
  );
}
